import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  BaseFilter,
  ListRequestOfBaseFilter,
  ListResponseOfProductVersion,
  ProductVersion,
} from "services/KnowfullyAdminClient";

type SelectProductVersionProps = Omit<
  AutocompleteWithQueryProps<ProductVersion>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectProductVersion = (props: SelectProductVersionProps) => {
  const { formatMessage: t } = useIntl();
  const { productService } = useGlobalContext();

  const fetchedProductVersions = useQuery<ListResponseOfProductVersion>(
    ["productVersions"],
    () =>
      productService.getProductVersions(
        ListRequestOfBaseFilter.fromJS({
          parameters: BaseFilter.fromJS({}),
          sortField: "name",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedProductVersions}
      failMessage={t({ id: "selectProductVersionFetchFailed" })}
    />
  );
};

export default SelectProductVersion;
